<template>
  <a
    class="download-button"
    :href="url"
    rel="noopener noreferrer"
    target="_blank"
    download
  >
    <BaseIcon
      class="icon"
      icon="ic_download"
      :colors="NebraskaColors.elementPrimary"
      aria-hidden="true"
    />
    <BaseText as="span">{{ computedTitle }}</BaseText>
  </a>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import { BaseIcon, BaseText } from '@warrenbrasil/nebraska-web';

@Component({
  components: { BaseIcon, BaseText }
})
export default class DownloadButton extends Vue {
  @Prop({ type: String, required: true })
  public url!: string;

  @Prop({ type: String })
  public title!: string;

  private get NebraskaColors() {
    return NebraskaColors;
  }

  private get computedTitle() {
    return this.title ? this.title : this.url.split('/').pop();
  }
}
</script>

<style lang="less" scoped>
.download-button {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: @size-spacing-x350 @size-spacing-x500;
  text-decoration: none;
  border-radius: 8px;
  background: @background-primary;
  transition: background 0.2s cubic-bezier(0.55, 0, 0.1, 1);

  &:hover {
    background: @background-hover;
  }
}

.icon {
  margin-right: @size-spacing-x400;
  line-height: 0;
}
</style>
